import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: '',
    userInfo: {},
    loginFlag: false,
    isAdmin: false,
    isRemAdmin: false,
    isUserAdmin: false
  },
  mutations: {
      setToken(state, data) {
        state.token = data
      },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setLoginFlag(state, loginFlag) {
      state.loginFlag = loginFlag
    },
    setIsAdmin(state, isAdmin) {
      state.isAdmin = isAdmin
    },
    setIsRemAdmin(state, isAdmin) {
      state.isRemAdmin = isAdmin
    },
    setIsUserAdmin(state, isAdmin) {
      state.isUserAdmin = isAdmin
    },
  },
  actions: {

  },
});
